import { apiRequest } from './apiClient.js'

export const profileService = {
  avatar: (options = {}) => apiRequest('/api/profile/avatar', options),
  notifications: (options = {}) => apiRequest('/api/profile/notifications', options),
  timezone: (options = {}) => apiRequest('/api/profile/timezone', options),
  timezones: (options = {}) => apiRequest('/api/profile/timezones/list', options),
  pageVisibility: (options = {}) => apiRequest('/api/page-visibility', options),
  adminPageVisibility: (options = {}) => apiRequest('/api/admin/page-visibility', options),
  pageVisibilityAt: (path, options = {}) => apiRequest(path, options),
}
